import './symbolIcons.css.js';
import { localizeWithPath } from '../../../../nls.js';
import { registerColor } from '../../../../platform/theme/common/colorUtils.js';
import { foreground } from '../../../../platform/theme/common/colors/baseColors.js';
import '../../../../platform/theme/common/colors/chartsColors.js';
import '../../../../platform/theme/common/colors/editorColors.js';
import '../../../../platform/theme/common/colors/inputColors.js';
import '../../../../platform/theme/common/colors/listColors.js';
import '../../../../platform/theme/common/colors/menuColors.js';
import '../../../../platform/theme/common/colors/minimapColors.js';
import '../../../../platform/theme/common/colors/miscColors.js';
import '../../../../platform/theme/common/colors/quickpickColors.js';
import '../../../../platform/theme/common/colors/searchColors.js';
const _moduleId = "vs/editor/contrib/symbolIcons/browser/symbolIcons";
registerColor('symbolIcon.arrayForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground,
}, ( localizeWithPath(
    _moduleId,
    0,
    'The foreground color for array symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.booleanForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground,
}, ( localizeWithPath(
    _moduleId,
    1,
    'The foreground color for boolean symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.classForeground', {
    dark: '#EE9D28',
    light: '#D67E00',
    hcDark: '#EE9D28',
    hcLight: '#D67E00'
}, ( localizeWithPath(
    _moduleId,
    2,
    'The foreground color for class symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.colorForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    3,
    'The foreground color for color symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.constantForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    4,
    'The foreground color for constant symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.constructorForeground', {
    dark: '#B180D7',
    light: '#652D90',
    hcDark: '#B180D7',
    hcLight: '#652D90'
}, ( localizeWithPath(
    _moduleId,
    5,
    'The foreground color for constructor symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.enumeratorForeground', {
    dark: '#EE9D28',
    light: '#D67E00',
    hcDark: '#EE9D28',
    hcLight: '#D67E00'
}, ( localizeWithPath(
    _moduleId,
    6,
    'The foreground color for enumerator symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.enumeratorMemberForeground', {
    dark: '#75BEFF',
    light: '#007ACC',
    hcDark: '#75BEFF',
    hcLight: '#007ACC'
}, ( localizeWithPath(
    _moduleId,
    7,
    'The foreground color for enumerator member symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.eventForeground', {
    dark: '#EE9D28',
    light: '#D67E00',
    hcDark: '#EE9D28',
    hcLight: '#D67E00'
}, ( localizeWithPath(
    _moduleId,
    8,
    'The foreground color for event symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.fieldForeground', {
    dark: '#75BEFF',
    light: '#007ACC',
    hcDark: '#75BEFF',
    hcLight: '#007ACC'
}, ( localizeWithPath(
    _moduleId,
    9,
    'The foreground color for field symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.fileForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    10,
    'The foreground color for file symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.folderForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    11,
    'The foreground color for folder symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.functionForeground', {
    dark: '#B180D7',
    light: '#652D90',
    hcDark: '#B180D7',
    hcLight: '#652D90'
}, ( localizeWithPath(
    _moduleId,
    12,
    'The foreground color for function symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.interfaceForeground', {
    dark: '#75BEFF',
    light: '#007ACC',
    hcDark: '#75BEFF',
    hcLight: '#007ACC'
}, ( localizeWithPath(
    _moduleId,
    13,
    'The foreground color for interface symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.keyForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    14,
    'The foreground color for key symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.keywordForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    15,
    'The foreground color for keyword symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.methodForeground', {
    dark: '#B180D7',
    light: '#652D90',
    hcDark: '#B180D7',
    hcLight: '#652D90'
}, ( localizeWithPath(
    _moduleId,
    16,
    'The foreground color for method symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.moduleForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    17,
    'The foreground color for module symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.namespaceForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    18,
    'The foreground color for namespace symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.nullForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    19,
    'The foreground color for null symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.numberForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    20,
    'The foreground color for number symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.objectForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    21,
    'The foreground color for object symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.operatorForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    22,
    'The foreground color for operator symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.packageForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    23,
    'The foreground color for package symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.propertyForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    24,
    'The foreground color for property symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.referenceForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    25,
    'The foreground color for reference symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.snippetForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    26,
    'The foreground color for snippet symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.stringForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    27,
    'The foreground color for string symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.structForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground,
}, ( localizeWithPath(
    _moduleId,
    28,
    'The foreground color for struct symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.textForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    29,
    'The foreground color for text symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.typeParameterForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    30,
    'The foreground color for type parameter symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.unitForeground', {
    dark: foreground,
    light: foreground,
    hcDark: foreground,
    hcLight: foreground
}, ( localizeWithPath(
    _moduleId,
    31,
    'The foreground color for unit symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
registerColor('symbolIcon.variableForeground', {
    dark: '#75BEFF',
    light: '#007ACC',
    hcDark: '#75BEFF',
    hcLight: '#007ACC',
}, ( localizeWithPath(
    _moduleId,
    32,
    'The foreground color for variable symbols. These symbols appear in the outline, breadcrumb, and suggest widget.'
)));
